import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import './AuthPages.css';

const API_BASE = process.env.REACT_APP_API_URL || '';

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [busy, setBusy] = useState(false);
  const [status, setStatus] = useState(token ? 'form' : 'error'); // form | success | error
  const [message, setMessage] = useState(token ? '' : 'No reset token provided.');

  const onSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      setMessage('Password must be at least 6 characters.');
      return;
    }
    if (password !== confirm) {
      setMessage('Passwords do not match.');
      return;
    }

    setBusy(true);
    setMessage('');
    try {
      const res = await fetch(`${API_BASE}/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, new_password: password }),
      });
      const data = await res.json();
      if (res.ok && data.success) {
        setStatus('success');
        setMessage(data.message || 'Password reset successfully!');
      } else {
        setStatus('error');
        setMessage(data.detail || data.error || 'Reset failed. The link may have expired.');
      }
    } catch {
      setStatus('error');
      setMessage('Network error. Please try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="ap-root">
      <div className="ap-card">
        {status === 'form' && (
          <>
            <div className="ap-icon">🔒</div>
            <h1 className="ap-title">Reset Your Password</h1>
            <p className="ap-subtitle">Choose a new password for your account.</p>

            <form onSubmit={onSubmit} className="ap-form">
              <div className="ap-pw-wrap">
                <input
                  className="ap-input"
                  type={showPw ? 'text' : 'password'}
                  placeholder="New password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  minLength={6}
                  required
                />
                {password && (
                  <button type="button" className="ap-pw-toggle" onClick={() => setShowPw(v => !v)}>
                    {showPw ? 'Hide' : 'Show'}
                  </button>
                )}
              </div>
              <input
                className="ap-input"
                type={showPw ? 'text' : 'password'}
                placeholder="Confirm password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                minLength={6}
                required
              />

              <button className="ap-btn" type="submit" disabled={busy}>
                {busy ? 'Resetting…' : 'Reset Password'}
              </button>

              {message && <div className="ap-note ap-error">{message}</div>}
            </form>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="ap-icon">✅</div>
            <h1 className="ap-title">Password Reset!</h1>
            <p className="ap-subtitle">{message}</p>
            <button className="ap-btn" onClick={() => navigate('/')}>
              Log In
            </button>
          </>
        )}

        {status === 'error' && !token && (
          <>
            <div className="ap-icon">❌</div>
            <h1 className="ap-title">Invalid Link</h1>
            <p className="ap-subtitle ap-error">{message}</p>
            <button className="ap-btn" onClick={() => navigate('/')}>
              Back to Home
            </button>
          </>
        )}

        {status === 'error' && token && (
          <>
            <div className="ap-icon">❌</div>
            <h1 className="ap-title">Reset Failed</h1>
            <p className="ap-subtitle ap-error">{message}</p>
            <button className="ap-btn" onClick={() => navigate('/')}>
              Back to Home
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default ResetPassword;
